{"errno":-2,"code":"ENOENT","syscall":"open","path":"/Users/christhielen/projects/ui-router/node_modules/ui-router-core/src/hooks/url.ts"}